import TrainerSlot from './TrainerSlot.jsx';

export default TrainerSlot;
